

// // import React, { useState, useEffect } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { postData } from "../../../../Services/Fetchnodeservices";
// // import AIScanModal from "./AIScanModal";
// // import EditItemModal from "./EditItemModal";

// // // ═════════════════════════════════════════════════════════════════════════════
// // // LUXURY THEME SYSTEM - Original Restored (No Changes)
// // // ═════════════════════════════════════════════════════════════════════════════
// // const getThemeStyles = (isDark) => {
// //   const themes = {
// //     dark: {
// //       background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
// //       border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
// //       textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
// //       primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
// //       successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
// //       gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
// //       gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
// //       shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
// //     },
// //     light: {
// //       background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
// //       border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
// //       textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
// //       primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
// //       successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
// //       gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
// //       gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
// //       shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
// //     },
// //   };
// //   return themes[isDark ? 'dark' : 'light'];
// // };

// // const BackIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>);
// // const ScanIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 12a9 9 0 1 1-9-9m9 0v6m0-6h-6"/><circle cx="12" cy="12" r="3"/></svg>);
// // const EditIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
// // const TrashIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
// // const ChevronLeftIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>);
// // const ChevronRightIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>);

// // const Admin = ({ isDark = true }) => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const ts = getThemeStyles(isDark);

// //   const [menuItems, setMenuItems] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [search, setSearch] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const itemsPerPage = 10;
// //   const [showAIScanModal, setShowAIScanModal] = useState(false);
// //   const [showEditModal, setShowEditModal] = useState(false);
// //   const [selectedItem, setSelectedItem] = useState(null);

// //   const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
// //   const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;

// //   const fetchMenu = async () => {
// //     if (!designation_id) return;
// //     setLoading(true);
// //     try {
// //       const response = await postData("restaurant/Menubydesignation_id", { designation_id });
// //       let itemsArray = [];
// //       if (Array.isArray(response) && response[0]?.items) {
// //         itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
// //       }
// //       setMenuItems(itemsArray);
// //     } catch (err) { console.error(err); }
// //     finally { setLoading(false); }
// //   };

// //   useEffect(() => { fetchMenu(); }, [designation_id]);

// //   const handleDelete = async (productId) => {
// //     if (!window.confirm("Bhai, pakka delete karna hai?")) return;
// //     try {
// //       const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
// //       if (resp.success) fetchMenu();
// //     } catch (e) { console.error(e); }
// //   };

// //   const filteredItems = menuItems.filter(item =>
// //     item.name?.toLowerCase().includes(search.toLowerCase()) ||
// //     item.category?.toLowerCase().includes(search.toLowerCase())
// //   );

// //   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
// //   const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

// //   const styles = {
// //     container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
// //     card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
// //     table: { width: "100%", borderCollapse: "collapse" },
// //     th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
// //     td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
// //     badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}`, whiteSpace: 'nowrap' },
// //     img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` },
// //     paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? ts.primary : ts.border}`, background: active ? ts.primary : ts.surface, color: active ? "white" : ts.textSecondary, cursor: "pointer", margin: "0 4px" })
// //   };

// //   return (
// //     <div style={styles.container}>
// //       <style>{`tr:hover { background: ${ts.primary}08 !important; } input:focus { border-color: ${ts.primary} !important; outline: none; }`}</style>
      
// //       <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px' }} onClick={() => navigate(-1)}>
// //         <BackIcon /> Back
// //       </button>

// //       <div style={styles.card}>
// //         <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
// //         <div style={{ marginTop: '20px' }}>
// //           <button onClick={() => setShowAIScanModal(true)} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
// //             <ScanIcon /> AI Scan Menu
// //           </button>
// //         </div>
// //       </div>

// //       <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

// //       <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
// //         <table style={styles.table}>
// //           <thead>
// //             <tr>
// //               <th style={styles.th}>Dish</th>
// //               <th style={styles.th}>Item Details</th>
// //               <th style={styles.th}>Menu Price</th>
// //               <th style={styles.th}>Cust. Price</th>
// //               <th style={styles.th}>Profit (20%)</th>
// //               <th style={styles.th}>Type</th>
// //               <th style={styles.th}>Actions</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {currentItems.map((item, idx) => {
// //               const variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
              
// //               return (
// //                 <tr key={idx}>
// //                   <td style={styles.td}>
// //                     <img src={item.pic1?.startsWith('http') ? item.pic1 : `https://zaptodoor.com/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
// //                   </td>
// //                   <td style={styles.td}>
// //                     <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
// //                     <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,30)}...</div>
// //                   </td>
                  
// //                   {/* MENU PRICE */}
// //                   <td style={styles.td}>
// //                     {variants.length > 0 ? variants.map((v, i) => {
// //                        const menuP = parseFloat(v.actual_price || (v.item_price_variant / 1.2) || 0);
// //                        return <div key={i} style={styles.badge}>{v.unit_value}: ₹{menuP.toFixed(0)}</div>
// //                     }) : `₹${parseFloat(item.requested_price || (item.price / 1.2)).toFixed(0)}`}
// //                   </td>

// //                   {/* CUSTOMER PRICE */}
// //                   <td style={styles.td}>
// //                     {variants.length > 0 ? variants.map((v, i) => {
// //                        return <div key={i} style={{ ...styles.badge, color: ts.success }}>{v.unit_value}: ₹{parseFloat(v.item_price_variant).toFixed(0)}</div>
// //                     }) : <span style={{ color: ts.success, fontWeight: 700 }}>₹{parseFloat(item.price).toFixed(0)}</span>}
// //                   </td>

// //                   {/* PROFIT COLUMN */}
// //                   <td style={styles.td}>
// //                     {variants.length > 0 ? variants.map((v, i) => {
// //                        const menuP = parseFloat(v.actual_price || (v.item_price_variant / 1.2) || 0);
// //                        const custP = parseFloat(v.item_price_variant || 0);
// //                        return <div key={i} style={{...styles.badge, background: ts.primary + '15', color: ts.primary, border: `1px solid ${ts.primary}33`}}>+₹{(custP - menuP).toFixed(0)}</div>
// //                     }) : <span style={{ color: ts.primary }}>+₹{(parseFloat(item.price) - parseFloat(item.requested_price || (item.price / 1.2))).toFixed(0)}</span>}
// //                   </td>

// //                   <td style={styles.td}>
// //                     <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
// //                   </td>
// //                   <td style={styles.td}>
// //                     <div style={{ display: 'flex', gap: '10px' }}>
// //                       <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><EditIcon /></button>
// //                       <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><TrashIcon /></button>
// //                     </div>
// //                   </td>
// //                 </tr>
// //               );
// //             })}
// //           </tbody>
// //         </table>
// //       </div>
      
// //       <AIScanModal isOpen={showAIScanModal} onClose={() => setShowAIScanModal(false)} designationId={designation_id} restaurantName={restaurantName} onItemsAdded={fetchMenu} />
// //       {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}
// //     </div>
// //   );
// // };
// // export default Admin;

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { postData, getData, serverURL } from "../../../../Services/Fetchnodeservices";
// // Saare icons yahan se import ho rahe hain
// import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight } from 'lucide-react'; 
// import AIScanModal from "./AIScanModal";
// import EditItemModal from "./EditItemModal";

// // ═════════════════════════════════════════════════════════════════════════════
// // LUXURY THEME SYSTEM
// // ═════════════════════════════════════════════════════════════════════════════
// const getThemeStyles = (isDark) => {
//   const themes = {
//     dark: {
//       background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
//       border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
//       textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
//       primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
//       successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
//       gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
//       gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
//       shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
//     },
//     light: {
//       background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
//       border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
//       textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
//       primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
//       successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
//       gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
//       gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
//       shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
//     },
//   };
//   return themes[isDark ? 'dark' : 'light'];
// };

// // Inline SVGs for basic UI actions
// const BackIcon = () => (<ChevronLeft size={18} />);
// const ScanIcon = () => (<Sparkles size={16} />);
// const EditIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>);
// const TrashIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);

// const Admin = ({ isDark = true }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const ts = getThemeStyles(isDark);

//   const [menuItems, setMenuItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
  
//   const [showAIScanModal, setShowAIScanModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
  
//   const [vendorMenus, setVendorMenus] = useState([]);
//   const [preSelectedImage, setPreSelectedImage] = useState(null);

//   const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
//   const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;

//   const fetchMenu = async () => {
//     if (!designation_id) return;
//     setLoading(true);
//     try {
//       const response = await postData("restaurant/Menubydesignation_id", { designation_id });
//       let itemsArray = [];
//       if (Array.isArray(response) && response[0]?.items) {
//         itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
//       }
//       setMenuItems(itemsArray);
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   };

//   const fetchVendorUploadedMenus = async () => {
//     try {
//       const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
//       if (resp.success) {
//         const allFiles = [];
//         resp.data.forEach(req => {
//             const files = req.files;
//             files.forEach(f => {
//                 if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
//             });
//         });
//         setVendorMenus(allFiles);
//       }
//     } catch (e) { console.error("Error fetching vendor menus:", e); }
//   };

//   useEffect(() => { 
//     fetchMenu(); 
//     fetchVendorUploadedMenus();
//   }, [designation_id]);

//   const handleDelete = async (productId) => {
//     if (!window.confirm("Bhai, pakka delete karna hai?")) return;
//     try {
//       const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
//       if (resp.success) fetchMenu();
//     } catch (e) { console.error(e); }
//   };

//   const handleScanVendorImage = (filename) => {
//     setPreSelectedImage(filename);
//     setShowAIScanModal(true);
//   };

//   const filteredItems = menuItems.filter(item =>
//     item.name?.toLowerCase().includes(search.toLowerCase()) ||
//     item.category?.toLowerCase().includes(search.toLowerCase())
//   );

//   const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   const styles = {
//     container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
//     card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
//     vendorSection: { marginBottom: '32px' },
//     vendorTitle: { fontSize: '18px', fontWeight: 700, marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' },
//     vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px' },
//     vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${ts.border}`, background: ts.surfaceLighter, overflow: 'hidden', cursor: 'pointer', position: 'relative', transition: '0.3s' },
//     table: { width: "100%", borderCollapse: "collapse" },
//     th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
//     td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
//     badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}` },
//     img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` }
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         tr:hover { background: ${ts.primary}08 !important; } 
//         input:focus { border-color: ${ts.primary} !important; outline: none; }
//         .vendor-box:hover { border-color: ${ts.primary} !important; transform: translateY(-3px); }
//         .vendor-box:hover .scan-overlay { opacity: 1 !important; }
//         ::-webkit-scrollbar { height: 6px; }
//         ::-webkit-scrollbar-thumb { background: ${ts.border}; borderRadius: 10px; }
//       `}</style>
      
//       <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px' }} onClick={() => navigate(-1)}>
//         <BackIcon /> Back
//       </button>

//       <div style={styles.card}>
//         <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
//             <div>
//                 <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
//                 <p style={{color: ts.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
//             </div>
//             <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
//                 <ScanIcon /> AI Scan Menu
//             </button>
//         </div>
//       </div>

//       {/* VENDOR MENU IMAGES SECTION */}
//       <div style={styles.vendorSection}>
//         <div style={styles.vendorTitle}>
//             <ImageIcon size={20} color={ts.primary}/> 
//             <span>Menu Pages & PDFs (Sent by Vendor)</span>
//         </div>
//         <div style={styles.vendorGrid}>
//           {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
//             <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
                
                
// <img 
//   src={`${serverURL}/uploads/${menu.filename}`} 
//   style={{width:'100%', height:'100%', objectFit:'cover'}} 
//   alt="menu-page" 
//   onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=No+Image"; }}
// />
//                 {/* <img src={`https://zaptodoor.com/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" /> */}
//                 <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
//                     <div style={{textAlign:'center'}}>
//                         <Sparkles size={20} color="white"/>
//                         <div style={{fontSize:'10px', fontWeight:700, color:'white', marginTop:'5px'}}>AI SCAN</div>
//                     </div>
//                 </div>
//                 <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'9px', color:'white', textAlign:'center'}}>
//                     Page {i+1}
//                 </div>
//             </div>
//           )) : (
//             [1,2,3,4,5].map(n => (
//                 <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: ts.textMuted, opacity: 0.5}}>
//                     <Plus size={24} />
//                     <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
//                 </div>
//             ))
//           )}
//         </div>
//       </div>

//       <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

//       <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>Dish</th>
//               <th style={styles.th}>Item Details</th>
//               <th style={styles.th}>Menu Price</th>
//               <th style={styles.th}>Cust. Price</th>
//               <th style={styles.th}>Profit (20%)</th>
//               <th style={styles.th}>Type</th>
//               <th style={styles.th}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.map((item, idx) => {
//               const variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
//               return (
//                 <tr key={idx}>
//                   <td style={styles.td}>
//                     <img src={item.pic1?.startsWith('http') ? item.pic1 : `https://zaptodoor.com/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
//                   </td>
//                   <td style={styles.td}>
//                     <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
//                     <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
//                   </td>
//                   <td style={styles.td}>
//                     {variants.length > 0 ? variants.map((v, i) => (
//                        <div key={i} style={styles.badge}>{v.unit_value}: ₹{parseFloat(v.actual_price || (v.item_price_variant / 1.2)).toFixed(0)}</div>
//                     )) : `₹${parseFloat(item.requested_price || (item.price / 1.2)).toFixed(0)}`}
//                   </td>
//                   <td style={styles.td}>
//                     {variants.length > 0 ? variants.map((v, i) => (
//                        <div key={i} style={{ ...styles.badge, color: ts.success, borderColor: ts.success+'33' }}>{v.unit_value}: ₹{parseFloat(v.item_price_variant).toFixed(0)}</div>
//                     )) : <span style={{ color: ts.success, fontWeight: 700 }}>₹{parseFloat(item.price).toFixed(0)}</span>}
//                   </td>
//                   <td style={styles.td}>
//                     {variants.length > 0 ? variants.map((v, i) => {
//                        const menuP = parseFloat(v.actual_price || (v.item_price_variant / 1.2) || 0);
//                        const custP = parseFloat(v.item_price_variant || 0);
//                        return <div key={i} style={{...styles.badge, background: ts.primary + '15', color: ts.primary, border: `1px solid ${ts.primary}33`}}>+₹{(custP - menuP).toFixed(0)}</div>
//                     }) : <span style={{ color: ts.primary }}>+₹{(parseFloat(item.price) - parseFloat(item.requested_price || (item.price / 1.2))).toFixed(0)}</span>}
//                   </td>
//                   <td style={styles.td}>
//                     <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
//                   </td>
//                   <td style={styles.td}>
//                     <div style={{ display: 'flex', gap: '10px' }}>
//                       <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><EditIcon /></button>
//                       <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><TrashIcon /></button>
//                     </div>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
      
//       <AIScanModal 
//         isOpen={showAIScanModal} 
//         onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
//         designationId={designation_id} 
//         restaurantName={restaurantName} 
//         onItemsAdded={fetchMenu}
//         preSelectedServerImage={preSelectedImage} 
//       />
      
//       {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}
//     </div>
//   );
// };
// export default Admin;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { postData, getData, serverURL } from "../../../../Services/Fetchnodeservices";
import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight } from 'lucide-react'; 
import AIScanModal from "./AIScanModal";
import EditItemModal from "./EditItemModal";

const getThemeStyles = (isDark) => {
  const themes = {
    dark: {
      background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
      border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
      textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
      primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
      successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
      gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
      gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
      shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
    },
    light: {
      background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
      border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
      textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
      primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
      successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
      gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
      gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
      shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
    },
  };
  return themes[isDark ? 'dark' : 'light'];
};

const Admin = ({ isDark = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const ts = getThemeStyles(isDark);

  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  
  const [showAIScanModal, setShowAIScanModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [vendorMenus, setVendorMenus] = useState([]);
  const [preSelectedImage, setPreSelectedImage] = useState(null);

  const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
  const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;

  const fetchMenu = async () => {
    if (!designation_id) return;
    setLoading(true);
    try {
      const response = await postData("restaurant/Menubydesignation_id", { designation_id });
      let itemsArray = [];
      if (Array.isArray(response) && response[0]?.items) {
        itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
      }
      setMenuItems(itemsArray);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const fetchVendorUploadedMenus = async () => {
    try {
      const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
      if (resp.success) {
        const allFiles = [];
        resp.data.forEach(req => {
            // Ensure files is parsed if it's a string
            const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
            files.forEach(f => {
                if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
            });
        });
        setVendorMenus(allFiles);
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => { 
    fetchMenu(); 
    fetchVendorUploadedMenus();
  }, [designation_id]);

  const handleDelete = async (productId) => {
    if (!window.confirm("Bhai, pakka delete karna hai?")) return;
    try {
      const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
      if (resp.success) fetchMenu();
    } catch (e) { console.error(e); }
  };

  const handleScanVendorImage = (filename) => {
    setPreSelectedImage(filename);
    setShowAIScanModal(true);
  };

  const filteredItems = menuItems.filter(item =>
    item.name?.toLowerCase().includes(search.toLowerCase()) ||
    item.category?.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination Logic
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const styles = {
    container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
    card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
    vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '32px' },
    vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${ts.border}`, background: ts.surfaceLighter, overflow: 'hidden', cursor: 'pointer', position: 'relative' },
    table: { width: "100%", borderCollapse: "collapse" },
    th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
    td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
    badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}` },
    img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` },
    paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? ts.primary : ts.border}`, background: active ? ts.primary : ts.surface, color: active ? "white" : ts.textSecondary, cursor: "pointer", margin: "0 4px", fontSize: '12px', fontWeight: 600 })
  };

  return (
    <div style={styles.container}>
      <style>{`
        tr:hover { background: ${ts.primary}08 !important; } 
        input:focus { border-color: ${ts.primary} !important; outline: none; }
        .vendor-box:hover .scan-overlay { opacity: 1 !important; }
        ::-webkit-scrollbar { height: 6px; }
        ::-webkit-scrollbar-thumb { background: ${ts.border}; borderRadius: 10px; }
      `}</style>
      
      <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px' }} onClick={() => navigate(-1)}>
        <ChevronLeft size={18}/> Back
      </button>

      <div style={styles.card}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
            <div>
                <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
                <p style={{color: ts.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
            </div>
            <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Sparkles size={16}/> AI Scan Menu
            </button>
        </div>
      </div>

      {/* VENDOR MENU IMAGES SECTION */}
      <div style={{marginBottom: '15px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px'}}>
         <ImageIcon size={18} color={ts.primary}/> Menu Pages & PDFs (Sent by Vendor)
      </div>
      <div style={styles.vendorGrid}>
        {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
          <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
              <img src={`${serverURL}/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=Menu+Page"; }}/>
              <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
                  <Sparkles size={20} color="white"/>
              </div>
              <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'10px', color:'white', textAlign:'center'}}>
                  Page {i+1}
              </div>
          </div>
        )) : [1,2,3,4,5].map(n => (
          <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: ts.textMuted, opacity: 0.5}}>
              <Plus size={24} />
              <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
          </div>
        ))}
      </div>

      <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

      <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Dish</th>
              <th style={styles.th}>Item Details</th>
              <th style={styles.th}>Menu Price</th>
              <th style={styles.th}>Cust. Price</th>
              <th style={styles.th}>Profit (20%)</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, idx) => {
              const variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
              return (
                <tr key={idx}>
                  <td style={styles.td}>
                    <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
                  </td>
                  <td style={styles.td}>
                    <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
                    <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
                  </td>
                  <td style={styles.td}>
                    {variants.length > 0 ? variants.map((v, i) => (
                       <div key={i} style={styles.badge}>{v.unit_value}: ₹{parseFloat(v.actual_price || (v.item_price_variant / 1.2)).toFixed(0)}</div>
                    )) : `₹${parseFloat(item.requested_price || (item.price / 1.2)).toFixed(0)}`}
                  </td>
                  <td style={styles.td}>
                    {variants.length > 0 ? variants.map((v, i) => (
                       <div key={i} style={{ ...styles.badge, color: ts.success }}>{v.unit_value}: ₹{parseFloat(v.item_price_variant).toFixed(0)}</div>
                    )) : <span style={{ color: ts.success, fontWeight: 700 }}>₹{parseFloat(item.price).toFixed(0)}</span>}
                  </td>
                  <td style={styles.td}>
                    {variants.length > 0 ? variants.map((v, i) => {
                       const menuP = parseFloat(v.actual_price || (v.item_price_variant / 1.2) || 0);
                       const custP = parseFloat(v.item_price_variant || 0);
                       return <div key={i} style={{...styles.badge, background: ts.primary + '15', color: ts.primary, border: `1px solid ${ts.primary}33`}}>+₹{(custP - menuP).toFixed(0)}</div>
                    }) : <span style={{ color: ts.primary }}>+₹{(parseFloat(item.price) - parseFloat(item.requested_price || (item.price / 1.2))).toFixed(0)}</span>}
                  </td>
                  <td style={styles.td}>
                    <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
                      <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* 🔥 RESTORED PAGINATION UI */}
        <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${ts.border}`, background: ts.surfaceLighter }}>
            <div style={{fontSize:'12px', color: ts.textMuted}}>
                Showing {currentItems.length} of {filteredItems.length} items
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button 
                  disabled={currentPage === 1} 
                  onClick={() => setCurrentPage(currentPage - 1)}
                  style={{...styles.paginationBtn(false), opacity: currentPage === 1 ? 0.5 : 1}}
                >
                    <ChevronLeft size={16}/>
                </button>
                
                {[...Array(totalPages)].map((_, i) => (
                    <button 
                      key={i} 
                      onClick={() => setCurrentPage(i + 1)}
                      style={styles.paginationBtn(currentPage === i + 1)}
                    >
                        {i + 1}
                    </button>
                ))}

                <button 
                  disabled={currentPage === totalPages} 
                  onClick={() => setCurrentPage(currentPage + 1)}
                  style={{...styles.paginationBtn(false), opacity: currentPage === totalPages ? 0.5 : 1}}
                >
                    <ChevronRight size={16}/>
                </button>
            </div>
        </div>
      </div>
      
      <AIScanModal 
        isOpen={showAIScanModal} 
        onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
        designationId={designation_id} 
        restaurantName={restaurantName} 
        onItemsAdded={fetchMenu}
        preSelectedServerImage={preSelectedImage} 
      />
      {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}
    </div>
  );
};
export default Admin;